import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import { XIcon } from "@heroicons/react/solid";

const ViewServiceLogsModal = ({ open, onClose, serviceName, logs }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="service-logs-modal"
      aria-describedby="modal-for-viewing-service-logs"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
      }}>
        <div className="flex justify-between items-center mb-4">
          <Typography variant="h6" component="h2" className="font-bold text-lg">
            {serviceName} Service Logs
          </Typography>
          <IconButton onClick={onClose} size="small">
            <XIcon className="h-5 w-5" />
          </IconButton>
        </div>

        <div className="border rounded-md overflow-hidden max-h-96 overflow-y-auto">
          {logs.length > 0 ? (
            logs.map((log, index) => (
              <div 
                key={index} 
                className={`p-4 border-b last:border-b-0 ${log.type === 'enabled' ? 'bg-color15/10' : 'bg-color13/10'}`}
              >
                <div className="flex items-center">
                  <div 
                    className={`h-3 w-3 rounded-full mr-3 ${log.type === 'enabled' ? 'bg-color15' : 'bg-color13'}`}
                  ></div>
                  <div>
                    <p className="text-sm">
                      This service was <span className={`font-medium ${log.type === 'enabled' ? 'text-color15' : 'text-color13'}`}>
                        {log.type}
                      </span> on {log.date}
                    </p>
                    {log.user && (
                      <p className="text-xs text-gray-600 mt-1">
                        by {log.user}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-6 text-center text-gray-500">
              No logs found for this service.
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ViewServiceLogsModal;
